import axiosInstance from "core/api/axiosInstance";
import { normalizeAlert, sortAlerts } from "../alertas/model/alertsModel";
export { normalizeAlert } from "../alertas/model/alertsModel";

export const getAlertsService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/alert/get-alerts");
    if (Number(data?.data?.status) >= 400)
      throw new Error(data.data.message || "Error al consultar alertas");
    const items = Array.isArray(data?.data?.data)
      ? data.data.data
      : Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data)
      ? data
      : null;
    if (!items) throw new Error("Formato de alertas inválido");
    const alerts = sortAlerts(
      items
        .filter((item) => !item?.deletedAt)
        .map(normalizeAlert)
        .filter(Boolean)
    );
    return {
      success: true,
      data: alerts,
      total: alerts.length,
      message: data.msm || data?.data?.message || "Alertas obtenidas",
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error al obtener alertas",
      data: [],
      total: 0,
    };
  }
};
